import * as v from 'valibot';

// NOTE: mirrors CommandCenterMap-BE `AdminUserDto`
// (src/app/http/admin/admin-users.service.ts) — keep the two in sync. Every
// DTO field MUST be declared: v.object strips undeclared keys silently, which
// is exactly how TMDXNC-37 lost caseLabel/organ. The round-trip test in
// adminUser.schema.test.ts is the guard.
export const adminUserSchema = v.object({
  /** Cognito subject — the identity key; presence frames carry these. */
  oid: v.pipe(v.string(), v.minLength(1)),
  name: v.string(),
  email: v.string(),
  groups: v.object({
    isAdmin: v.boolean(),
    isStatsGroup: v.boolean(),
    isCCGroup: v.boolean(),
  }),
  online: v.boolean(),
  /** ISO 8601, or null = UNKNOWN (never seen, or Redis flushed). Render as a
   * dash — never "never", never new Date(null). */
  lastSeenAt: v.nullable(v.string()),
  /**
   * Per-account activity recording (TMDXNC-362) plus its stated reason, owner
   * and expiry (TMDXNC-363). FLAT, mirroring the BE DTO: `groups` is the
   * authorization vocabulary the FE tests membership against, and a monitoring
   * attribute is not an authorization group.
   */
  isActivityMonitored: v.boolean(),
  activityMonitoringReason: v.nullable(v.string()),
  /** The acting admin's oid, not a display name. */
  activityMonitoringSetBy: v.nullable(v.string()),
  /** ISO 8601, or null. */
  activityMonitoringExpiresAt: v.nullable(v.string()),
  createdAt: v.string(),
});

/**
 * The BE returns a bare array (`GET /api/admin/users`); this wraps it into
 * the `ResponseResult` envelope `validateAndTransformResponse` expects —
 * same move as `nopResources.api.ts`'s `getNopCSShifts`, whose upstream shape also
 * isn't the repo's native `{ data, dataGeneratedAt, errors, … }` envelope.
 */
export const adminUsersResponseSchema = v.object({
  data: v.array(adminUserSchema),
  dataGeneratedAt: v.nullable(v.string()),
  errors: v.nullable(v.array(v.unknown())),
  expires: v.nullable(v.string()),
  errorsGeneratedAt: v.nullable(v.string()),
});
